<template>
  <div class="return-button-container">
    <button class="return-button-content" @click="back">
    </button>
  </div>
</template>

<script>
export default {
  name: 'ReturnButton',
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {
    back: function () {
      if (this.$route.name === "MainPage") {
        return;
      }
      this.$router.go(-1);
    }
  },
  mounted() {
  },
  destroyed() {
  },
  // beforeRouteLeave(to, from, next) {
  //   if (to.path === "/mainPage") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // }
}
</script>

<style scoped>
.return-button-content {
  background-image: url("../assets/image/returnButton/ReturnButton.png");
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  background-color: transparent;
  border: 0;
}

.return-button-container {
  width: 15vw;
  height: 15vw;
  top: 8vw;
  left: 9vw;
  position: absolute;
}
</style>
